import PropTypes from 'prop-types'

const DescripcionProducto = ({ value, onChange, vieneDeAdministrar }) => {
  return (
    <>
      {!vieneDeAdministrar && (
        <p className="descripcion-cuadro-publicacion">
          Descripcion del producto (máximo 1000 caracteres)
        </p>
      )}
      <textarea
        name="descripcion"
        value={value}
        onChange={onChange}
        spellCheck="true"
        rows="5"
        className="text-area text-area-descripcion d-none d-md-block"
      ></textarea>
      <textarea
        name="descripcion"
        value={value}
        onChange={onChange}
        spellCheck="true"
        rows="5"
        className="text-area text-area-descripcion d-block d-md-none"
      ></textarea>
    </>
  )
}

DescripcionProducto.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  vieneDeAdministrar: PropTypes.bool
}

export default DescripcionProducto
